var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal modal-mask" }, [
    _c("div", { staticClass: "modal-dialog modal-wrapper" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "modal-content modal-container",
          style: _vm.containerStyle,
        },
        [
          _c("div", { staticClass: "modal-header py-1 gap-3" }, [
            _c(
              "div",
              { staticClass: "modal-title h5 mb-0 flex-grow-1" },
              [
                _vm._t("header", function () {
                  return [_vm._v(" Warning ")]
                }),
              ],
              2
            ),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-link btn-sm border-0 p-1 mb-0 flex-shrink-0 ms-auto",
                attrs: { type: "button", "aria-label": "Cerrar modal" },
                on: { click: _vm.hideModal },
              },
              [
                _c("i", {
                  staticClass: "el-icon-close fs-6",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ]),
          _vm._t("sub-header"),
          _c(
            "div",
            {
              staticClass: "modal-body",
              class: _vm.bodyClass,
              style: _vm.bodyStyle,
            },
            [
              _vm._t("body", function () {
                return [_vm._v(" Seguro desea realizar esta acción ")]
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "modal-footer" },
            [
              _vm._t("footer", function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("hide")
                        },
                      },
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("accepted")
                        },
                      },
                    },
                    [_vm._v(" Aceptar ")]
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }